import { render, staticRenderFns } from "./DescriptionAssuranceVieComponent.vue?vue&type=template&id=6598cde4&scoped=true"
import script from "./DescriptionAssuranceVieComponent.vue?vue&type=script&lang=js"
export * from "./DescriptionAssuranceVieComponent.vue?vue&type=script&lang=js"
import style0 from "./DescriptionAssuranceVieComponent.vue?vue&type=style&index=0&id=6598cde4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6598cde4",
  null
  
)

export default component.exports